import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useProfileStore = defineStore('profile', () => {
  const profileUuid = ref<string>();

  return {
    profileUuid,
  };
});
